import $foreign from "./foreign.cjs";
var freeze = $foreign.freeze;
var $$new = $foreign.new;
var peekImpl = $foreign.peekImpl;
var poke = $foreign.poke;
var popImpl = $foreign.popImpl;
var pushAll = $foreign.pushAll;
var shiftImpl = $foreign.shiftImpl;
var sortByImpl = $foreign.sortByImpl;
var splice = $foreign.splice;
var thaw = $foreign.thaw;
var toAssocArray = $foreign.toAssocArray;
var unsafeFreeze = $foreign.unsafeFreeze;
var unsafeThaw = $foreign.unsafeThaw;
var unshiftAll = $foreign.unshiftAll;
export { freeze, $$new as new, peekImpl, poke, popImpl, pushAll, shiftImpl, sortByImpl, splice, thaw, toAssocArray, unsafeFreeze, unsafeThaw, unshiftAll };
